import { render, staticRenderFns } from "./newProjectReports.vue?vue&type=template&id=7a7848e8&scoped=true&"
import script from "./newProjectReports.vue?vue&type=script&lang=ts&"
export * from "./newProjectReports.vue?vue&type=script&lang=ts&"
import style0 from "./newProjectReports.vue?vue&type=style&index=0&id=7a7848e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7848e8",
  null
  
)

component.options.__file = "newProjectReports.vue"
export default component.exports